<template>
  <b-modal
    id="modal-custom_1"
    :ok-title="$t('Save')"
    :cancel-title="$t('Abort')"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    hideHeaderClose
    @ok.prevent="saveData"
    @cancel="resetModal"
    @shown="showModal"
    size="lg"
    centered
  >
    <b-overlay :show="show" rounded="sm">
      <b-row>
        <b-col cols="12" class="modalTitle">
          <h2 class="font-weight-bolder" v-if="!editTitle">
            {{ pinpoint.label }}
            <b-button
              v-if="pinpoint.type.editable"
              class="btn-icon rounded-circle"
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                @click="editTitle = true"
                variant="flat-primary"
              />
            </b-button>
          </h2>
          <b-form-input
            v-if="editTitle"
            type="text"
            v-model="pinpoint.label"
            maxlength="25"
            autofocus
          />
          <!-- <span>- {{ $t("pin_point.insert_description") }} -</span> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <Vueditor id="editor_free_1"></Vueditor>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="pin_hide">
          <icon-selector
            v-if="pinpoint.type.editable"
            v-model="icon"
          ></icon-selector>
          <footer-pin-point v-model="hide_pinpont"></footer-pin-point>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormInput,
  BButton,
  BModal,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import FooterPinPoint from "./footer";
import IconSelector from "./icon-selector";

import { getPinpoint, updatePinpoint } from "@api/pinpoint";
import { createEditor } from "vueditor";

export default {
  props: ["pinpoint"],
  name: "pin-point-custom_1",
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BFormInput,
    BButton,
    BModal,
    BFormFile,
    BOverlay,
    FooterPinPoint,
    IconSelector,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      original_pin: null,
      editor: null,
      hide_pinpont: !this.pinpoint.active,
      show: false,
      editTitle: false,
      icon: "",
    };
  },
  methods: {
    showModal() {
      this.editor = createEditor("#editor_free_1",{
        toolbar: [
         'removeFormat', 'undo', '|', 'element', 'fontName', 'foreColor', 'backColor', 'divider',
        'bold', 'italic', 'underline', 'strikeThrough', 'link', 'divider', 'subscript', 'superscript',
        'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', '|', 'indent', 'outdent',
        'insertOrderedList', 'insertUnorderedList', '|', 'picture', 'table', '|', "sourceCode",
        ],
        uploadUrl: '',
        id: '',
        classList: []
      });
      this.editor.upload = function(obj, callback) {
        var reader = new FileReader();
        reader.readAsDataURL(obj.files[0]);
        reader.onloadend = function() {
          callback(reader.result);
        };
      };
      const $this = this;
      getPinpoint($this.pinpoint.id)
        .then((data) => {
          $this.original_pin = data;
          $this.icon = data.icon;
          if (data.fields.text != null) {
            $this.editor.setContent(data.fields_html_content[data.fields.text]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      const $this = this;
      this.show = true;
      this.editTitle = false;
      let formData = new FormData();
      formData.append("label", $this.pinpoint.label);
      formData.append("icon", $this.icon);
      formData.append("text", $this.editor.getContent());
      formData.append("active", $this.hide_pinpont ? 0 : 1);
      updatePinpoint($this.pinpoint.id, formData)
        .then((data) => {
          this.$emit("onSave");
          this.$bvModal.hide("modal-custom_1");
          this.show = false;
        })
        .catch((error) => {
          console.log(error);
          this.show = false;
        });
    },
    resetModal() {
      this.editTitle = false;
      this.icon = this.original_pin.icon;
      this.pinpoint.label = this.original_pin.label;
      this.editor.setContent(this.original_pin.fields.text);
      this.hide_pinpont = !this.pinpoint.active;
      this.$bvModal.hide("modal-custom_1");
    },
  },
};
</script>

<style></style>
